import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBranding } from "../context/BrandingContext";
import { apiOrigin } from "../services/api";
import { isStaffRole } from "../utils/staffRoles";
import { clearAuthSession } from "../utils/authSession";
import { ROUTES } from "../routes/paths";
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("userRole") || "user";
  const [menuOpen, setMenuOpen] = useState(false);
  const { branding } = useBranding();

  const logoSrc =
    branding.logo_url &&
    (branding.logo_url.startsWith("http") ? branding.logo_url : `${apiOrigin}${branding.logo_url}`);

  const handleLogout = () => {
    clearAuthSession();
    setMenuOpen(false);
    navigate(ROUTES.HOME, { replace: true });
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="mkc-navbar">
      <Link to={ROUTES.DASHBOARD} className="mkc-nav-brand" onClick={closeMenu}>
        <span className="mkc-nav-brand-inner">
          {logoSrc ? (
            <img
              src={logoSrc}
              alt=""
              className="mkc-nav-brand-logo"
              decoding="async"
              loading="eager"
            />
          ) : (
            <span className="mkc-nav-brand-emoji" aria-hidden="true">
              {branding.logo_emoji || "❤"}
            </span>
          )}
          <span>{branding.app_name}</span>
        </span>
      </Link>
      <button
        type="button"
        className="mkc-nav-toggle"
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
        aria-controls="mkc-primary-nav"
        onClick={() => setMenuOpen((o) => !o)}
      >
        <span className="mkc-nav-toggle-bar" />
        <span className="mkc-nav-toggle-bar" />
        <span className="mkc-nav-toggle-bar" />
      </button>
      <ul
        id="mkc-primary-nav"
        className={`mkc-nav-links ${menuOpen ? "mkc-nav-open" : ""}`}
      >
        <li><Link to={ROUTES.DASHBOARD} onClick={closeMenu}>Dashboard</Link></li>
        <li><Link to={ROUTES.HEALTH} onClick={closeMenu}>Health</Link></li>
        <li><Link to={ROUTES.PREGNANCY} onClick={closeMenu}>Pregnancy</Link></li>
        <li><Link to={ROUTES.PERIOD} onClick={closeMenu}>Period & ovulation</Link></li>
        <li><Link to={ROUTES.BABY} onClick={closeMenu}>Baby Care</Link></li>
        <li><Link to={ROUTES.APPOINTMENTS} onClick={closeMenu}>Appointments</Link></li>
        <li><Link to={ROUTES.REPORTS} onClick={closeMenu}>Reports</Link></li>
        <li><Link to={ROUTES.ARTICLES} onClick={closeMenu}>Articles</Link></li>
        <li><Link to={ROUTES.WELLNESS} onClick={closeMenu}>Daily Check‑in</Link></li>
        <li><Link to={ROUTES.TOOLS} onClick={closeMenu}>Tools</Link></li>
        <li><Link to={ROUTES.BABY_NAMES} onClick={closeMenu}>Baby Names</Link></li>
        <li><Link to={ROUTES.STORE} onClick={closeMenu}>Essential Store</Link></li>
        <li><Link to={ROUTES.PROFILE} onClick={closeMenu}>Profile</Link></li>
        <li><Link to={ROUTES.SUBSCRIPTION} onClick={closeMenu}>Subscription</Link></li>
        {isStaffRole(role) && (
          <li><Link to={ROUTES.ADMIN} className="mkc-nav-admin" onClick={closeMenu}>Admin</Link></li>
        )}
        <li><button type="button" className="mkc-nav-logout" onClick={handleLogout}>Logout</button></li>
      </ul>
      {menuOpen && <div className="mkc-nav-overlay" onClick={closeMenu} aria-hidden="true" />}
    </nav>
  );
};

export default Navbar;
